export default "__VITE_ASSET__BTCj$zTt__"